<hc-modal>
    <hc-modal-header>
        @if (!isEdit) {
            <div><span class="icon-left icon-data-source-add"></span>Create Source</div>
        } @else if (isViewOnlyMode) {
            <div><span class="icon-left icon-data-source"></span>Source Details</div>
        } @else {
            <div><span class="icon-left icon-data-source-edit"></span>Edit Source</div>
        }
    </hc-modal-header>
    <form [formGroup]="tenantSourceForm">
        <hc-tab-set direction="horizontal" #tabSet (selectedTabChange)="tabChanged($event)">
            @if (!isEdit && !isViewOnlyMode) {
                <hc-tab>
                    <hc-tab-title> Templates </hc-tab-title>

                    <cdp-template-list
                        #templateList
                        (createSourcesClicked)="onCreateSource()"
                        (templateChanged)="onTemplateChanged($event)"
                    ></cdp-template-list>
                    <hc-modal-footer>
                        <button hc-button buttonStyle="link" (click)="cancel()">Cancel</button>
                        <button hc-button buttonStyle="primary" (click)="tabSet.selectTab(sourceInfo)">
                            <span *ngIf="!saveInProgress">Next <span class="icon-right icon-chev-right"></span></span>
                            <hc-progress-dots
                                color="light"
                                [isMini]="true"
                                [isCentered]="false"
                                *ngIf="saveInProgress"
                            ></hc-progress-dots>
                            <div *ngIf="saveInProgress">Saving...</div>
                        </button>
                    </hc-modal-footer>
                </hc-tab>
            }
            <ng-container>
                <hc-tab #sourceInfo>
                    <hc-tab-title>
                        Source Info
                        @if (shouldDisplaySourceInfoInvalidIndicator && !isViewOnlyMode) {
                            <span class="icon-right icon-warn"></span>
                        }
                    </hc-tab-title>
                    <div class="cdp-modal-tab-content cdp-fade-in">
                        <div class="cdp-row">
                            <hc-form-field class="col-8">
                                <hc-label
                                    >Name

                                    <span
                                        *ngIf="!selectedTemplate"
                                        class="icon-info cdp-info-ico cdp-info-ico-right"
                                        [hcTooltip]="sourceDescriptionHelp"
                                    ></span>
                                    <div *ngIf="selectedTemplate" class="source-template-name-container">
                                        <span class="icon-left icon-books"></span>
                                        <span
                                            >Source Template:
                                            <span>{{ selectedTemplate.name }} </span>
                                        </span>
                                    </div>
                                </hc-label>

                                <input
                                    hcInput
                                    maxlength="255"
                                    formControlName="sourceDescription"
                                    [required]="true"
                                    (input)="onNameChange()"
                                />
                                <hc-error>
                                    <div *ngIf="sourceDescriptionControl?.errors?.['required']">Name is required.</div>
                                    <div *ngIf="sourceDescriptionControl?.errors?.['pattern']">
                                        Name may only contain alphanumeric characters, spaces, or underscores
                                    </div>
                                    <div *ngIf="sourceDescriptionControl?.errors?.['notUnique']">
                                        Source name must be unique to this tenant. Another source is already using this
                                        name.
                                    </div>
                                </hc-error>
                            </hc-form-field>
                            <div class="cdp-form-field col-4">
                                <label for="devStatus"
                                    >Deployment Status<span cdpRequiredMarker></span
                                    ><span
                                        class="icon-info cdp-info-ico cdp-info-ico-right"
                                        [hcTooltip]="devStatusHelp"
                                    ></span
                                ></label>
                                <ng-select
                                    formControlName="status"
                                    bindValue="value"
                                    [items]="devStatuses"
                                    placeholder="Select a status..."
                                    [clearable]="false"
                                    [searchable]="false"
                                    appendTo="body"
                                    labelForId="devStatus"
                                    [required]="true"
                                >
                                    <ng-template ng-option-tmp ng-label-tmp let-item="item">
                                        <div class="source-dev-status-option" [title]="item.description">
                                            <span
                                                class="cdp-dev-status-indicator cdp-dev-status-indicator-{{
                                                    item.value
                                                }}"
                                            ></span>
                                            <span>{{ item.name }}</span>
                                        </div>
                                    </ng-template>
                                </ng-select>
                                <p class="error" *ngIf="statusControl.touched && statusControl.invalid">
                                    Deployment status is required.
                                </p>
                            </div>
                        </div>
                        <div class="connection-type-row">
                            <div class="cdp-row">
                                <div class="cdp-form-field" [ngClass]="showIrtSelect ? 'col-8' : 'col-12'">
                                    <label for="connectionTypes"
                                        >Connection Type<span cdpRequiredMarker></span
                                        ><span
                                            class="icon-info cdp-info-ico cdp-info-ico-right"
                                            [hcTooltip]="connectionTypesHelp"
                                        ></span>
                                    </label>
                                    <ng-select
                                        formControlName="connectionType"
                                        [items]="connectionTypes"
                                        bindValue="connectionType"
                                        bindLabel="display"
                                        placeholder="Select a connection type..."
                                        [searchable]="true"
                                        [clearable]="false"
                                        appendTo="body"
                                        labelForId="connectionTypes"
                                        [loading]="connectionTypesLoading"
                                        [required]="true"
                                        [searchFn]="connectionTypeSearchFn"
                                        (change)="onConnectionTypeChange()"
                                    >
                                        <ng-template ng-option-tmp ng-label-tmp let-item="item">
                                            <div class="connection-type-option">
                                                <span
                                                    class="cdp-connection-type-badge connection-type-option-badge"
                                                    [title]="item.connectionType"
                                                    >{{ item.connectionType }}</span
                                                >
                                                <span
                                                    #descSpan
                                                    class="type-desc"
                                                    [hcTooltip]="
                                                        item.tooltip ||
                                                        (isTextTruncated(descSpan) ? item.description : '')
                                                    "
                                                    [hcTooltipDisabled]="!item.tooltip && !isTextTruncated(descSpan)"
                                                    >{{ item.description }}</span
                                                >
                                            </div>
                                        </ng-template>
                                    </ng-select>
                                    <p
                                        class="error"
                                        *ngIf="connectionTypeControl.touched && connectionTypeControl.invalid"
                                    >
                                        Connection type is required.
                                    </p>
                                </div>
                                @if (showIrtSelect) {
                                    <div class="cdp-form-field col-4">
                                        <label for="irtNumber"
                                            >IRT<span cdpRequiredMarker></span
                                            ><span
                                                class="icon-info cdp-info-ico cdp-info-ico-right"
                                                [hcPop]="irtHelpInfo"
                                                trigger="hover"
                                                verticalAlign="above"
                                            ></span>
                                        </label>
                                        <ng-select
                                            formControlName="irtNumber"
                                            [items]="availableIrtOptions"
                                            placeholder="Select ..."
                                            [clearable]="false"
                                            appendTo="body"
                                            labelForId="irtNumber"
                                            [loading]="connectionTypesLoading"
                                        >
                                            <ng-template ng-option-tmp ng-label-tmp let-item="item">
                                                {{ getIrtOptionLabel(item) }}
                                            </ng-template>
                                        </ng-select>
                                        <p class="error" *ngIf="irtNumberControl.touched && irtNumberControl.invalid">
                                            Input required
                                        </p>
                                        <hc-pop #irtHelpInfo [disableStyle]="true" verticalAlign="above">
                                            <div class="hc-tooltip">
                                                Integrated Run Time:<br />0 = Auto Resolve<br />3 = Managed Virtual
                                                Network<br />1,2,4+ = Self Hosted
                                            </div>
                                        </hc-pop>
                                    </div>
                                }
                            </div>
                        </div>
                        <div class="cdp-form-field">
                            <label for="systemTypes"
                                >System Type<span cdpRequiredMarker></span
                                ><span
                                    class="icon-info cdp-info-ico cdp-info-ico-right"
                                    [hcTooltip]="systemTypesHelp"
                                ></span
                            ></label>
                            <ng-select
                                formControlName="systemType"
                                [items]="systemTypes"
                                bindValue="systemTypeId"
                                bindLabel="display"
                                placeholder="Select a system type..."
                                [searchable]="true"
                                [clearable]="false"
                                appendTo="body"
                                labelForId="systemTypes"
                                [loading]="systemTypesLoading"
                                [required]="true"
                            >
                            </ng-select>
                            <p class="error" *ngIf="systemTypeControl.touched && systemTypeControl.invalid">
                                System type is required.
                            </p>
                        </div>

                        <hc-accordion class="cdp-tight-accordion">
                            <hc-accordion-toolbar
                                >Advanced<span class="icon-chev-down icon-right"></span
                            ></hc-accordion-toolbar>
                            <div class="cdp-row">
                                <hc-form-field class="col-6">
                                    <hc-label
                                        >Connection Key<span
                                            class="icon-info cdp-info-ico cdp-info-ico-right"
                                            [hcTooltip]="connectionKeyHelp"
                                        ></span
                                    ></hc-label>
                                    <input hcInput maxlength="127" formControlName="connectionKey" [required]="true" />
                                    <hc-error>
                                        <div *ngIf="connectionKeyControl?.errors?.['required']">
                                            Connection key is required.
                                        </div>
                                        <div *ngIf="connectionKeyControl?.errors?.['pattern']">
                                            Connection key must be alphanumeric and start with a letter. It may also
                                            contain dashes, but no more than one in a row.
                                        </div>
                                    </hc-error>
                                </hc-form-field>
                                <div class="col-6">
                                    <hc-form-field>
                                        <hc-label>
                                            Table Prefix
                                            <span
                                                class="icon-info cdp-info-ico cdp-info-ico-right"
                                                [hcTooltip]="tablePrefixHelp"
                                            >
                                            </span>
                                        </hc-label>
                                        <input
                                            hcInput
                                            maxlength="255"
                                            formControlName="tablePrefix"
                                            [required]="true"
                                        />
                                        <hc-error>
                                            <div *ngIf="tablePrefixControl?.errors?.['required']">
                                                Table Prefix is required.
                                            </div>
                                            <div *ngIf="tablePrefixControl?.errors?.['pattern']">
                                                Table Prefix must be alphanumeric and start with a letter. It may also
                                                contain underscores.
                                            </div>
                                            <div *ngIf="tablePrefixControl?.errors?.['notUnique']">
                                                Table Prefix must be unique to this tenant. Another source is already
                                                using this table prefix.
                                            </div>
                                        </hc-error>
                                    </hc-form-field>
                                    <hc-progress-dots
                                        *ngIf="tablePrefixControl?.pending"
                                        [isMini]="true"
                                    ></hc-progress-dots>
                                </div>
                            </div>

                            <div class="cdp-row">
                                <hc-form-field class="col-6">
                                    <hc-label>
                                        Legacy Data Source ID
                                        <span
                                            class="icon-info cdp-info-ico cdp-info-ico-right"
                                            [hcTooltip]="dataSourceIdHelp"
                                        >
                                        </span>
                                    </hc-label>
                                    <input hcInput maxlength="255" formControlName="dataSourceId" />
                                </hc-form-field>

                                <hc-form-field
                                    *cdpHideIfFeatureFlagOff="featureflags.ShowNewIngestConfigurationFields"
                                    class="col-6"
                                >
                                    <hc-label>
                                        Max Connections
                                        <span
                                            class="icon-info cdp-info-ico cdp-info-ico-right"
                                            [hcTooltip]="maximumConcurrentConnectionsHelp"
                                        >
                                        </span>
                                    </hc-label>
                                    <input hcInput type="number" formControlName="maximumConcurrentConnections" />
                                    <hc-icon hcPrefix fontSet="icon" fontIcon="icon-plug"></hc-icon>
                                </hc-form-field>
                            </div>
                        </hc-accordion>
                    </div>
                    <hc-modal-footer
                        ><!--source Info-->
                        @if (isLegacyConnectionDetailsUpdate) {
                            <ng-template *ngTemplateOutlet="connectionDetailsUpdate"></ng-template>
                        }
                        @if (isViewOnlyMode) {
                            <button hc-button buttonStyle="secondary" (click)="cancel()">Close</button>
                        } @else {
                            <button hc-button buttonStyle="link" (click)="cancel()">Cancel</button>
                        }
                        @if (!isEdit && !isViewOnlyMode) {
                            <button
                                hc-button
                                buttonStyle="primary"
                                (click)="tabSet.selectTab(connectionDetails)"
                                [disabled]="!connectionType"
                            >
                                <span *ngIf="!saveInProgress"
                                    >Next <span class="icon-right icon-chev-right"></span
                                ></span>
                                <hc-progress-dots
                                    color="light"
                                    [isMini]="true"
                                    [isCentered]="false"
                                    *ngIf="saveInProgress"
                                ></hc-progress-dots>
                                <div *ngIf="saveInProgress">Saving...</div>
                            </button>
                        }
                        @if (isEdit && !isViewOnlyMode) {
                            <button hc-button buttonStyle="primary" (click)="save()" [disabled]="saveIsDisabled()">
                                <span *ngIf="!saveInProgress">Save</span>
                                <hc-progress-dots
                                    color="light"
                                    [isMini]="true"
                                    [isCentered]="false"
                                    *ngIf="saveInProgress"
                                ></hc-progress-dots>
                                <div *ngIf="saveInProgress">Saving...</div>
                            </button>
                        }
                    </hc-modal-footer>
                </hc-tab>
            </ng-container>
            <ng-container>
                <hc-tab #connectionDetails>
                    <hc-tab-title>
                        Connection Details
                        @if (displayConnectionDetailsInvalidIndicator && !isViewOnlyMode) {
                            <span class="icon-right icon-warn"></span>
                        }
                    </hc-tab-title>
                    <div *ngIf="!connectionType" class="cdp-grid-empty cdp-grid-empty-small cdp-fade-in">
                        @if (!isViewOnlyMode) {
                            <span class="cdp-grid-empty-ico icon-warn"></span>
                        }
                        <h5>Incomplete Source Information</h5>
                        <p>You'll need to select a connection type before entering connection details.</p>
                    </div>

                    <!-- Connection details not required -->
                    <div
                        *ngIf="connectionType && !isLegacyConnectionType && !hasConnectionConfig"
                        class="cdp-grid-empty cdp-grid-empty-small cdp-fade-in"
                    >
                        <span class="cdp-grid-empty-ico icon-status-success"></span>
                        <p>Connection details are not required<br />for the selected connection type.</p>
                    </div>

                    <div *ngIf="saveErrorMessage">
                        <hc-banner type="alert">
                            <div>
                                @if (!isViewOnlyMode) {
                                    <span class="icon-left icon-error"></span>
                                }
                                Tenant source save failed:
                                {{ saveErrorMessage }}
                            </div>
                        </hc-banner>
                    </div>
                    <div
                        *ngIf="connectionType && (isLegacyConnectionType || hasConnectionConfig)"
                        class="cdp-fade-in connection-detail-form"
                    >
                        <hc-banner>
                            <div class="cdp-modal-info-banner-content">
                                <span class="icon-left icon-plug-circle-bolt"></span>{{ connectionTypeDescriptive }}
                                Connection Details
                            </div>
                        </hc-banner>

                        @if (hasConnectionConfig) {
                            <cdp-dynamic-source-connection-details
                                #dynamicForm
                                [connectionConfig]="dynamicConnectionTypeConfig"
                                [existingConnectionDetails]="tenantSource.connectionDetails"
                                [isOriginalConnectionType]="connectionType === tenantSource.connectionType"
                                [isReadOnly]="isViewOnlyMode"
                            ></cdp-dynamic-source-connection-details>
                        } @else {
                            @if (isLegacyConnectionType) {
                                @if (isEdit && isUnknownConnectionStringFormat && !isConnectionStringError) {
                                    <div class="cdp-warn-chip-container">
                                        <hc-chip color="yellow" width="99%">
                                            <div class="cdp-warn-message-container">
                                                @if (!isViewOnlyMode) {
                                                    <hc-icon class="icon-warn" hcIconSm></hc-icon>
                                                }
                                                <div>{{ unknownConnectionStringFormatMessage }}</div>
                                            </div>
                                        </hc-chip>
                                    </div>
                                }

                                <div class="cdp-modal-tab-top-content" *ngIf="showConnectionStringSelect()">
                                    <hc-checkbox formControlName="usingConnectionString" [tight]="true"
                                        >Enter as connection string</hc-checkbox
                                    >
                                </div>
                                <div class="cdp-modal-tab-content cdp-fade-in">
                                    <hc-form-field *ngIf="usingConnectionString" class="cdp-fade-in">
                                        <hc-label
                                            >Connection String<span
                                                class="icon-info cdp-info-ico cdp-info-ico-right"
                                                [hcTooltip]="connectionStringHelp"
                                            ></span
                                        ></hc-label>
                                        <input
                                            hcInput
                                            maxlength="255"
                                            type="password"
                                            formControlName="connectionString"
                                            [required]="usingConnectionString && isFieldRequired"
                                        />
                                        <hc-error> Connection string is required. </hc-error>
                                    </hc-form-field>
                                    <div *ngIf="isLegacyConnectionType && !usingConnectionString" class="cdp-fade-in">
                                        <div class="cdp-row">
                                            <hc-form-field [ngClass]="fsTypeSelected ? 'col-12' : 'col-8'">
                                                <hc-label>Host</hc-label>
                                                <input
                                                    hcInput
                                                    placeholder="hostname.com"
                                                    maxlength="256"
                                                    formControlName="host"
                                                    [required]="!usingConnectionString && isFieldRequired"
                                                />
                                                <hc-error>
                                                    <div *ngIf="hostControl?.errors?.['required']">
                                                        Host is required.
                                                    </div>
                                                    <div *ngIf="hostControl?.errors?.['invalidUrl']">
                                                        Host must be a valid URL.
                                                    </div>
                                                </hc-error>
                                            </hc-form-field>
                                            <hc-form-field class="col-4" *ngIf="sftpTypeSelected">
                                                <hc-label
                                                    >Port<span
                                                        class="icon-info cdp-info-ico cdp-info-ico-right"
                                                        [hcTooltip]="portHelp"
                                                    ></span
                                                ></hc-label>
                                                <input
                                                    hcInput
                                                    placeholder="{{ portPlaceholderText }}"
                                                    type="number"
                                                    formControlName="port"
                                                    [required]="sftpTypeSelected"
                                                />
                                                <hc-error>
                                                    <div *ngIf="portControl?.errors?.['invalidPort']">
                                                        Port must be an integer between 0 and 65535.
                                                    </div>
                                                </hc-error>
                                            </hc-form-field>
                                        </div>
                                    </div>
                                    <div *ngIf="requiresDatabaseName && !usingConnectionString">
                                        <hc-form-field>
                                            <hc-label>Database Name</hc-label>
                                            <input
                                                hcInput
                                                placeholder="Enter db name..."
                                                maxlength="128"
                                                formControlName="database"
                                                [required]="
                                                    requiresDatabaseName && !usingConnectionString && isFieldRequired
                                                "
                                            />
                                            <hc-error> Database name is required. </hc-error>
                                        </hc-form-field>
                                    </div>
                                    <div *ngIf="isLegacyConnectionType && !usingConnectionString">
                                        <hc-form-field>
                                            <hc-label>User ID</hc-label>
                                            <hc-icon
                                                hcPrefix
                                                fontSet="icomoon-font-family"
                                                fontIcon="icon-user"
                                            ></hc-icon>
                                            <input
                                                hcInput
                                                maxlength="128"
                                                formControlName="user"
                                                [required]="!usingConnectionString && isFieldRequired"
                                            />
                                            <hc-error> User ID is required. </hc-error>
                                        </hc-form-field>
                                        <hc-form-field>
                                            <hc-label>Password</hc-label>
                                            <hc-icon
                                                hcPrefix
                                                fontSet="icomoon-font-family"
                                                fontIcon="icon-lock"
                                            ></hc-icon>
                                            <input
                                                hcInput
                                                maxlength="128"
                                                type="password"
                                                formControlName="password"
                                                [required]="!usingConnectionString && isFieldRequired"
                                            />
                                            <hc-error> Password is required. </hc-error>
                                        </hc-form-field>
                                    </div>
                                </div>
                            }
                        }
                        <div *ngIf="editConnectionStringOnLoadError" class="alert-wrapper">
                            <div
                                class="alert alert-warning connection-string-error-alert"
                                *ngIf="editConnectionStringOnLoadError"
                            >
                                @if (!isViewOnlyMode) {
                                    <span class="icon-warn icon-left"></span>
                                }
                                <span>
                                    Connection details could not be retrieved.
                                    <a hc-button buttonStyle="link-inline" (click)="toggleConnectionStringError()">
                                        {{ displayConnectionStringLoadError ? 'Hide' : 'See' }} error.
                                    </a>
                                </span>
                            </div>
                            <div
                                class="alert alert-details connection-string-error-details-alert cdp-slide-down"
                                *ngIf="displayConnectionStringLoadError"
                            >
                                {{ editConnectionStringOnLoadError }}
                            </div>
                        </div>
                    </div>
                    <hc-modal-footer
                        ><!-- connection Details-->
                        @if (isLegacyConnectionDetailsUpdate || isDynamicConnectionDetailsUpdate) {
                            <ng-template *ngTemplateOutlet="connectionDetailsUpdate"></ng-template>
                        }

                        @if (isViewOnlyMode) {
                            <button hc-button buttonStyle="link" (click)="tabSet.selectTab(sourceInfo)">
                                <span class="icon-left icon-chev-left"></span>Back
                            </button>
                            <button hc-button buttonStyle="secondary" (click)="cancel()">Close</button>
                        } @else {
                            <button hc-button buttonStyle="link" (click)="cancel()">Cancel</button>
                            <button hc-button buttonStyle="link" (click)="tabSet.selectTab(sourceInfo)">
                                <span class="icon-left icon-chev-left"></span>Back
                            </button>
                        }

                        @if (!isViewOnlyMode) {
                            <button hc-button buttonStyle="primary" (click)="save()" [disabled]="saveIsDisabled()">
                                <span *ngIf="!saveInProgress">{{ saveButtonText() }}</span>
                                <hc-progress-dots
                                    color="light"
                                    [isMini]="true"
                                    [isCentered]="false"
                                    *ngIf="saveInProgress"
                                ></hc-progress-dots>
                                <div *ngIf="saveInProgress">Saving...</div>
                            </button>
                        }
                    </hc-modal-footer>
                </hc-tab>
            </ng-container>
        </hc-tab-set>
    </form>
</hc-modal>

<ng-template #connectionDetailsUpdate>
    <div class="cdp-warn-chip-container" style="width: 100%">
        <hc-chip color="yellow">
            <div class="cdp-warn-message-container">
                @if (!isViewOnlyMode) {
                    <hc-icon class="icon-warn" hcIconSm></hc-icon>
                }
                <div>
                    <span>Connection details have been modified.</span>
                </div>
            </div>
        </hc-chip>
    </div>
</ng-template>
